const EMAIL_LINK_RE =
  /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

/** Split copy and wrap email addresses as mailto links. */
export const linkifyEmails = (text) => {
  const raw = String(text || "");
  const parts = [];
  let last = 0;
  let match;
  EMAIL_LINK_RE.lastIndex = 0;
  while ((match = EMAIL_LINK_RE.exec(raw))) {
    if (match.index > last) parts.push(raw.slice(last, match.index));
    const address = match[1];
    parts.push(
      <a key={`${address}-${match.index}`} href={`mailto:${address}`}>
        {address}
      </a>,
    );
    last = match.index + match[0].length;
  }
  if (last < raw.length) parts.push(raw.slice(last));
  return parts;
};
